// Adds dropcap to first paragraph
import imgURL from '../img/destinedtoburn-full.png';

let contentBody = document.querySelector('.story-template > .story-body');
let firstGraph = document.querySelector('.story-body > p:not(:empty)');
let dateline = document.querySelector('.story-body > .dateline');

let CTA = document.createElement('div');
CTA.className = 'lp-link';
CTA.innerHTML = `
    <figure><img src="${imgURL}" alt="Destined to burn logo"></figure>
    <span class="copy-text">This story is part of the Destined to Burn series, a collaboration with newsrooms across California and the Associated Press.</span>
    <span class="copy-cta"><b><a href="https://www.sacbee.com/news/state/california/fires/article228475464.html">View all stories</a></b></span>`;

document.addEventListener('DOMContentLoaded', function () {
    
    contentBody.insertBefore(CTA, firstGraph);
    
});